import community from './community.js';
import contentDetails from './content-details.js';
import proofing from './proofing.js';
import shared from './shared.js';
import users from './users.js';
import errors from './errors.js';
import folders from './folders.js';
import operationsPortal from './operations-portal.js';
import recording from './recording.js';
import groups from './groups.js';
import media from './media.js';
import companies from './companies.js';
import optionsTraining from './options-training.js';
import request from './request.js';
import uploader from './uploader.js';
import organization from './organization.js';
import room from './room.js';
import writeup from './writeup.js';
import leads from './leads.js';
import simpleLogin from './simple-login.js';
import microlearning from './microlearning.js';

export default {
    community,
    contentDetails,
    proofing,
    shared,
    users,
    errors,
    folders,
    operationsPortal,
    recording,
    groups,
    media,
    companies,
    optionsTraining,
    request,
    uploader,
    organization,
    room,
    writeup,
    leads,
    simpleLogin,
    microlearning,
}
